import { Arrow, Arrowkeys, CloseIcon, EscIcon, LClickIcon, TutorialHand, WasdKeys } from "../../assets/icons";
import style from "./style.module.css"

interface ITutorialPopupProps
{
    showPopup: boolean;
    isMobile: boolean;
    closePopup: () => void;
}

export const TutorialPopup: React.FC<ITutorialPopupProps> = ({ showPopup, isMobile, closePopup }) =>
{

    return (
      
        <div className={`${style.blurBG} ${showPopup ? style.blurBGEnabled : ""}`} onClick={closePopup}>

        {!isMobile ? (

                        <div className={`${style.container} ${showPopup ? style.enabled : ""}`}>
        <div className={style.escCont}>
          <div className={style.esc}>
            <EscIcon />
          </div>
          <div className={style.escTxt}>
            Press the ESC key to exit the store
          </div>
        </div>


        <div className={style.lClickCont}>
          <div className={style.lClick}>
            <LClickIcon />
          </div>
          <div className={style.lClickTxt}>
            Click & drag on left mouse button to look around
          </div>
        </div>

               <div className={style.lClickCont}>
          <div className={style.lClick}>
            <LClickIcon />
          </div>
          <div className={style.lClickTxt}>
            Left click on desired item to interact with it
          </div>
        </div>





        <div className={style.jystCont}>
          <div className={style.jyst}>
            <div className={style.innerJyst}></div>
          </div>
          <div className={style.txt}>Use joystick to navigate</div>
        </div>

        <div className={style.wasdCont}>
          <div className={style.wasd}>
            <WasdKeys />
          </div>
          <div className={style.wasdTxt}>
            Press these keys on your keyboard to navigate
          </div>
        </div>

        <div className={style.arrowsCont}>
          <div className={style.arrows}>
            <Arrowkeys />
          </div>
          <div className={style.arrowsTxt}>
            Use the Arrow keys on your keyboard to navigate
          </div>
        </div>

        <div className={style.closeBtn} onClick={closePopup}>
          <CloseIcon />
        </div>
      </div>

        ) 
        
        : 
        
        (
            <div className={`${style.mobCont} ${showPopup ? style.enabled : ""}`}>
                
                <div className={style.mobTutTxt} >

                    <div className={style.closeBtn} onClick={closePopup}>
                         <CloseIcon />
                     </div>
                    <div className={style.mobTutTxtBold}>Quick tips</div>
                    <div className={style.mobTutTxtSemi}>Swipe to pan around <br/> the environment</div>

                </div>
            
                <div className={style.arrwCont}>
                    <Arrow className={style.flipped}/>
                <Arrow/>
                    </div>
                <TutorialHand className={style.handAnim}/>
            </div>
        )}
        



        </div>
      
    );
}